import { ListGroupBy } from '@core/models/common/list-group-by';
import { ListItem } from '@core/models/common/list-item';
import moment from 'moment';
import { ListSortBy } from '../common/list-sort-by';
import { FORMAT } from '@core/utils/formats';

export class BillingInvoice implements ListItem {
    public id: string;
    public owner_id: string;
    public desc: string;
    public date: string;
    public download_options: {
        mime_type: string,
        new_window: boolean,
        path: string,
        title: string
    }[];
    public status: string;
    public start_balance: number;
    public end_balance: number;
    public subtotal: number;
    public total: number;
    public receipt_number: string; // need to confirm
    public attempt_count: number;
    public period_start: string;
    public period_end: string;
    public next_payment_attempt: string; // need to confirm
    public line_items: any[];
    public loading: boolean = false;
    public selected: boolean;

    /**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        return true;
    }

    /**
     * Validates the kiosk matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        return true;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        return '';
    }

    /**
     * Custom valueOf allows for param based sort / comparision
     * @param ref
     * @returns {any}
     */
    valueOf(ref?: any): any {
        let res: any;
        if (ref === ListSortBy.TIME) {
            res = moment(this.date, FORMAT.DATE_SHORT);
        }

        return res || this;
    }

    get historyDate(): string {
        return moment(this.date, FORMAT.DATE_SHORT).format(
            FORMAT.DATETIME_LONG
        );
    }
}
